<mat-card class="menupannel">
    <div class="resUser">
      <button mat-flat-button (click)="showMyDrive()">
        My Drive 
      </button>
    </div>
    <div class="d">
      <button mat-flat-button (click)="showDocDetail()">
        <mat-icon>keyboard_arrow_left</mat-icon> Details
      </button> 
    </div>
  </mat-card>
  
    <div class="coreholder" fxLayout="row">
  
      <!-- My Drive -->
  
      <mat-card class="myDrive" [ngClass]="{'open': showmyDrive }">
          <app-left-menu></app-left-menu>
      </mat-card>
    
      <div class="myDriveOverlay" (click)="showMyDrive()" [ngClass]="{'open': showmyDrive }"></div>
        
      <!-- My Drive -->
    
      <!-- Core page Structure -->
      <div class="corepages">
    
        <!-- Filter -->
        <mat-card class="filter">
          <label>Starred</label>
          <div class="slAct">
            
            <button mat-icon-button><mat-icon>delete</mat-icon></button>
          </div>
          <mat-form-field appearance="fill" >
            <mat-label>Search... </mat-label>
            <input matInput type="text"  maxlength="30">
            <button matSuffix mat-icon-button aria-label="Clear" >
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
    
          <button  class="filterbtn"   mat-icon-button >
            <mat-icon>filter_list</mat-icon>
          </button>
  
  
        </mat-card>
        <!-- Filter -->
     
  
        <mat-card class="emailList">
          <div class="list ehead">
              <div class="check"></div>
              <div class="icon"></div>
              <div class="subject">Subject</div>            
              <div class="status">From</div>
             
              <div class="update">Received On</div>
              <div class="action">Action</div>
          </div>
          <div class="list erow">
            <div class="check"><mat-checkbox color="primary" ></mat-checkbox>  </div>
            <div class="icon"><mat-icon>done</mat-icon></div>
            <div class="subject">
              <h4>Signature on rent agreement</h4>            
            </div>
            <div class="status">Matt Mcalpin</div>
     
  
            <div class="update">25/07/20</div>
            <div class="action actbtns">
               
              <button mat-icon-button matTooltipClass="Delete" matTooltip="View Status"> <mat-icon>delete</mat-icon> </button>
            </div>
          </div>
         
  
        </mat-card>
        
      </div>
      <!-- Core page Structure -->
  
  
      <!-- Document Detail  -->
      <mat-card class="documentDetail" [ngClass]="{'open': docDetail }">
        <app-doc-detail></app-doc-detail>
      </mat-card>
      <div class="documentDetailOverlay" (click)="showDocDetail()" [ngClass]="{'open': docDetail }"></div>
  
      <!-- Document Detail -->
    
    </div>
    
